import Base from "../../base";
import { useTranslation } from "react-i18next";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import axiosConfig from "../../../services/Axios";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faToggleOff,
  faToggleOn,
  faTrashAlt,
  faArrowsRepeat,
  faRectangleHistoryCircleUser,
} from "@fortawesome/pro-regular-svg-icons";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Auth from "../../../services/Auth";
import RoleLabel from "../../../components/ui/RoleLabel";
import Pagination from "../../../components/ui/Pagination";
import Title from "../../../components/ui/Title";
import PopoverMenu from "../../../components/ui/PopoverMenu";
import { faEdit } from "@fortawesome/pro-solid-svg-icons";

function Users() {
  const [users, setUsers] = useState();
  const authUser = useSelector((state) => state.auth);
  const [formData, setFormData] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    if (!formData) return;
    loadUsers(formData);
  }, [formData]);

  const loadUsers = (formData) => {
    let itemsPerPage = 10;
    let url =
      process.env.REACT_APP_API_URL +
      (formData?.page ? formData?.page + "&" : "/api/users?");

    if (itemsPerPage) {
      url = url + "&itemsPerPage=" + itemsPerPage;
    }

    axiosConfig.get(url).then((response) => {
      if (response?.status === 200 && response?.data) {
        setUsers(response.data);
      }
    });
  };

  const toggleEnabledUser = (user, data) => {
    Swal.fire({
      text: t("global.edit") + " " + user.email + " ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_modify"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig
          .patch(process.env.REACT_APP_API_URL + user["@id"], data, {
            headers: { "Content-Type": "application/merge-patch+json" },
          })
          .then((response) => {
            if (response?.status === 200 && response?.data) {
              let newUsers = users["hydra:member"].map((u) =>
                user["@id"] === u["@id"] ? response.data : u
              );
              setUsers((u) => (u, { "hydra:member": newUsers }));

              toast.success(t("settings.users.user_edited"), {
                theme: "colored",
                hideProgressBar: true,
              });
            }
          });
      }
    });
  };

  const handleDeleteUser = (user) => {
    Swal.fire({
      text: t("global.form.delete") + " " + user.email + " ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_delete"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig
          .delete(process.env.REACT_APP_API_URL + user["@id"])
          .then((response) => {
            if (response?.status === 204) {
              toast.success(t("settings.users.user_deleted"), {
                theme: "colored",
                hideProgressBar: true,
              });

              setUsers(
                (us) => (
                  us,
                  {
                    "hydra:member": us["hydra:member"].filter(
                      (u) => user["@id"] !== u["@id"]
                    ),
                  }
                )
              );
            }
          });
      }
    });
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const switchUser = (newUser) => {
    newUser.partner = newUser.partner["@id"];
    return Auth.switchUser(newUser);
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 lg:p-8 lg:px-10 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10 lg:bg-white rounded-lg">
          <Title
            icon={faRectangleHistoryCircleUser}
            title={t("settings.users.list")}
          />
          <div className="bg-bioport-blue-light grid grid-cols-12 text-white font-bold px-4 p-3">
            <div className="col-span-8 lg:col-span-4">{t("login.email")}</div>
            <div className="col-span-2 hidden lg:block">
              {t("settings.users.partner")}
            </div>
            <div className="col-span-2 hidden lg:block text-center">
              {t("global.form.role")}
            </div>
            <div className="col-span-2 lg:col-span-1 text-center">
              {t("global.form.switch")}
            </div>
            <div className="col-span-2 hidden lg:block text-center">
              {t("global.form.enabled")}
            </div>
            <div className="col-span-2 lg:col-span-1"></div>
          </div>
          <div className="">
            {users &&
              users["hydra:member"].map((u, key) => {
                const links = [
                  {
                    link:
                      u.id !== authUser?.user?.id
                        ? "/settings/users/" + u.id
                        : "/settings/account",
                    icon: faEdit,
                    label: t("global.edit"),
                    class:
                      "hover:cursor-pointer hover:underline text-bioport-blue",
                  },
                ];

                if (u.email !== authUser.user.username) {
                  links.push({
                    link: () => toggleEnabledUser(u, { enabled: !u.enabled }),
                    icon: u.enabled ? faToggleOn : faToggleOff,
                    label: t("global.form.enabled"),
                    class: "hover:cursor-pointer hover:underline mt-2",
                  });

                  links.push({
                    link: () => handleDeleteUser(u),
                    icon: faTrashAlt,
                    label: t("global.form.delete"),
                    class:
                      "hover:cursor-pointer hover:underline text-red-600 mt-2",
                  });
                }

                return (
                  <div
                    className={`grid grid-cols-12 px-4 p-3 hover:bg-gray-50 ${
                      key % 2 === 0 && "bg-gray-100"
                    }`}
                    key={key}
                  >
                    <div className="col-span-8 lg:col-span-4">
                      <Link
                        to={
                          u.id !== authUser?.user?.id
                            ? "/settings/users/" + u.id
                            : "/settings/account"
                        }
                        className="hover:underline"
                      >
                        {u.email}
                      </Link>
                    </div>
                    <div className="col-span-2 hidden lg:block">
                      <Link
                        to={`/settings/partners/` + u.partner.id}
                        className="hover:underline"
                      >
                        {u.partner.name}
                      </Link>
                    </div>
                    <div className="col-span-2 hidden lg:block text-center">
                      <RoleLabel roles={u.roles} />
                    </div>
                    <div className="col-span-2 lg:col-span-1 text-center">
                      {u.id !== authUser.user.id &&
                        !authUser.user.switchOriginalUser && (
                          <FontAwesomeIcon
                            icon={faArrowsRepeat}
                            className="text-lg hover:scale-110 cursor-pointer"
                            onClick={() => {
                              switchUser(u);
                            }}
                          />
                        )}
                    </div>
                    <div
                      className={`hidden lg:block col-span-2 text-center ${
                        !u.enabled && "text-gray-400"
                      } hover:text-bioport-blue cursor-pointer`}
                    >
                      {u.id !== authUser.user.id && (
                        <FontAwesomeIcon
                          icon={u.enabled ? faToggleOn : faToggleOff}
                          className="text-xl"
                          onClick={() => {
                            toggleEnabledUser(u, { enabled: !u.enabled });
                          }}
                        />
                      )}
                    </div>
                    <div className="col-span-2 lg:col-span-1 text-center">
                      <PopoverMenu links={links} />
                    </div>
                  </div>
                );
              })}
          </div>
          {users &&
            users["hydra:member"] &&
            users["hydra:totalItems"] > users["hydra:member"].length &&
            users["hydra:view"] && (
              <Pagination
                data={users}
                onClick={(page) => {
                  setFormData((formData) => ({
                    ...formData,
                    page: page,
                  }));
                }}
              />
            )}
        </div>
      </div>
    </Base>
  );
}

export default Users;
